<template>
  <div class="case">
    <banner :img="zhaopinBanner" title="诚聘英才" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="job-desc">
          <p>人才理念</p>
          <div>
            公司发展目标为拥有一流技术、一流产品和一流服务体系的国际知名企业。 期待有梦想的你加盟！
          </div>
        </div>
        <div class="table-wrap">
          <el-table
            :data="tableData"
            style="width: 100%"
            border=true>
            <el-table-column
              prop="name"
              label="职位名称"
              width="180">
            </el-table-column>
            <el-table-column
              prop="type"
              label="职位类别"
              width="180">
            </el-table-column>
            <el-table-column
              prop="address"
              label="工作地点">
            </el-table-column>
            <el-table-column
              prop="date"
              label="发布日期">
            </el-table-column>
          </el-table>
        </div>
        <div class="job-wrap">
          <p class="job-title">前端研发工程师</p>
          <p>
              学历要求：本科及以上<br>
              工作经验：2年及以上<br>
              岗位职责：<br>
              1、负责项目PC端和移动端的web前端开发工作，配合调取后端工程师的API接口实现功能；<br>
              2、负责将设计原型图快速转化成HTML+CSS，并保证较高的设计还原度和良好的浏览器兼容性;；<br>
              3、利用最新的前端技术对前端页面进行优化，致力于改善用户体验。<br>
              任职要求：<br>
              1、熟悉HTML5/CSS3/JavaScript/jQuery/Ajax，对JavaScript开发有深入理解，熟悉w3c网页标准；<br>
              2、了解mvc设计模式，了解vue,react或其他主流开发框架；<br>
              3、对解决浏览器兼容性问题有一定的经验；<br>
              4、至少一年以上的GIS项目开发经验；<br>
              5、熟练阅读英文资料；<br>
              6、有canvas、svg 图层开发经验者优先，有node.js 使用经验者优先，有优秀个人作品者优先。<br>
          </p>
        </div>
        <hr>
        <div class="job-wrap">
          <p class="job-title">销售经理</p>
          <p>
              学历要求：本科及以上<br>
              工作经验：3年及以上<br>
              岗位职责：<br>
              1、收集客户信息，了解客户需求，制定客户销售方案；<br>
              2、负责与客户联系，维护客户关系，积极开发新客户资源；<br>
              3、提升产品市场影响力。<br>
              任职要求：<br>
              1、本科及以上学历，营销及海洋类相关专业优先考虑；<br>
              2、3年以上销售相关工作经验；<br>
              3、年龄要求20岁-40岁，普通话标准；<br>
              4、具有较强的组织协调能力、团队管理能力和执行力；<br>
              5、学习能力强，工作积极热情，性格活泼开朗。<br>
          </p>
        </div>
        <hr>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: false,
      caseList: [],
      zhaopinBanner:require("../assets/img/zhaopin.png"),
      tableData: [{
        name: '前端研发工程师',
        date: '2024-5-1',
        address: '珠海市',
        type:'信息技术类'
      }, {
        name: '销售经理',
        date: '2024-5-1',
        address: '珠海市',
        type:'市场类'
      }]
    };
  },
  mounted() {
    window.console.log("case");
    this.loading = false;
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     //console.log(response);
    //     this.caseList = response.data;
    //     //window.console.log(this.caseList);
    //     this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

 <style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  // background-color: #14679f;

  &-section {
    width: 100%;
    &-content {
      width: 1240px;
      min-height: 500px;
      margin: 0 auto;
      background-color: #fff;
      .table-wrap{
        text-align: center;
        display: flex;
        margin: 20px 10%;
        border: 1px solid #EBEEF5;
      }
      ::v-deep.el-table th > .cell {
        text-align: center;
      }
      ::v-deep.el-table .cell {
        text-align: center;
      }
      hr{
        background: #d8dce0;
        height: 1px;
        border: none;
      }
      .job-desc{
        text-align: center;
        padding: 50px 0;
        p{
          font-size: 30px;
          margin-bottom: 20px;
        }
      }
      .job-wrap{
          text-align: left;
          padding: 20px 10%;
          font-size: 14px;
          color: #354463;
          line-height: 1.5;
          .job-title{
            font-size: 16px;
            color: #303133;
            margin-bottom: 10px;
            font-weight: bold;
          }
      }
    }
  }
}
</style>